import { useFormikContext } from 'formik'
import { useApolloClient } from '@apollo/client'
import { useUserSession } from '@src/utils/useUserSession'
import {
  SemiConfigFormValues,
  SpecificationResultType,
} from './ProductsConfiguration'
import {
  GetSemiConfigDropDownListDocument,
  GetSemiConfigDropDownListQuery,
} from '@src/queries/SemiConfigSpecificationQuery.generated'

interface SpecificationsQueryProps {
  physicalMaterial?: string
  modification?: string
  structure?: string
  species?: string
  titer?: string
  volume?: string
  scale?: string
  purification?: string
}

const useSpecifications = () => {
  const formik = useFormikContext<SemiConfigFormValues>()
  const client = useApolloClient()
  const { userSession } = useUserSession()
  const SpecificationsQuery = async ({
    physicalMaterial,
    modification,
    structure,
    species,
    titer,
    volume,
    scale,
    purification,
  }: SpecificationsQueryProps): Promise<SpecificationResultType> => {
    const emptyResponse: SpecificationResultType = {
      physicalMaterial: [],
      amount: [],
      titer: [],
      volume: [],
      aliquot: [],
      modification: [],
      structure: [],
      species: [],
      scale: [],
      purification: [],
      format: [],
    }
    try {
      formik.setFieldValue('loading', true, false)
      const variables = {
        input: {
          countryCode: userSession.country,
          physicalMaterial:
            physicalMaterial || formik.values.specifications.physicalMaterial,
          modification:
            modification || formik.values.specifications?.modification,
          structure: structure || formik.values.specifications?.structure,
          species: species || formik.values.specifications?.species,
          titer: titer || formik.values.specifications?.titer,
          volume: volume || formik.values.specifications?.volume,
          scale: scale || formik.values.specifications?.scale,
          purification:
            purification || formik.values.specifications?.purification,
          store: userSession.store,
        },
      }
      const result = await client.query<GetSemiConfigDropDownListQuery>({
        query: GetSemiConfigDropDownListDocument,
        variables,
      })

      formik.setFieldValue('loading', false, false)
      const data = result.data.getSemiConfigDropDownList
      return {
        physicalMaterial: data.physicalMaterial || [],
        amount: data.amount || [],
        titer: data.titer || [],
        volume: data.volume || [],
        aliquot: data.aliquot || [],
        modification: data.modification || [],
        structure: data.structure || [],
        species: data.species || [],
        scale: data.scale || [],
        purification: data.purification || [],
        format: data.format || [],
      }
    } catch (err) {
      formik.setFieldValue('loading', false, false)
      return emptyResponse
    }
  }
  return {
    SpecificationsQuery,
  }
}

export default useSpecifications
